import { ENDPOINT } from "../../../../config";

const SESSIONS_URL = `${ENDPOINT}ai-chat/sessions`;
const AI_CREDIT_QUOTA_URL = `${ENDPOINT}billing/ai-credit-quota`;

function handleUnauthorized(response) {
  if (response.status === 401) {
    localStorage.clear();
    window.location.assign("/login");
    throw new Error("Unauthorized");
  }
}

async function request(url, options, token) {
  const response = await fetch(url, {
    ...options,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...(options?.headers || {}),
    },
  });

  handleUnauthorized(response);

  if (!response.ok) {
    let detail = `Request failed (${response.status})`;
    try {
      const errBody = await response.json();
      detail = errBody?.message || detail;
    } catch {
      // ignore
    }
    throw new Error(detail);
  }

  if (response.status === 204) return null;
  return response.json();
}

export async function fetchSessions(token, signal) {
  const json = await request(SESSIONS_URL, { method: "GET", signal }, token);
  return json?.data?.records || [];
}

export async function fetchSession(id, token, signal) {
  const json = await request(`${SESSIONS_URL}/${id}`, { method: "GET", signal }, token);
  return json?.data || null;
}

export async function deleteSession(id, token, signal) {
  await request(`${SESSIONS_URL}/${id}`, { method: "DELETE", signal }, token);
  return true;
}

export async function fetchAiCreditQuota(token, signal) {
  const json = await request(AI_CREDIT_QUOTA_URL, { method: "GET", signal }, token);
  return json?.data || null;
}

export async function pinSession(id, pinned, token, signal) {
  const json = await request(
    `${SESSIONS_URL}/${id}/pin`,
    { method: "POST", body: JSON.stringify({ pinned: !!pinned }), signal },
    token
  );
  return json?.data?.session || null;
}
